import { senderNameResource } from '@jira/router-resources__customer-service-sender-name/src/senderNameResource.tsx';
import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsCustomerNotificationsRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsCustomerNotificationsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	HelpCenterSettingsCustomerNotifications,
	LazyHelpCenterSettingsCustomerNotifications,
} from './ui/customer-notifications/index.tsx';

export const helpCenterSettingsCustomerNotificationsRouteEntry: Route = createEntry(
	helpCenterSettingsCustomerNotificationsRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.customer-notifications',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: HelpCenterSettingsCustomerNotifications,
		forPaint: [LazyAtlassianNavigation, LazyHelpCenterSettingsCustomerNotifications],
		resources: [
			...getServiceDeskSettingsResources(),
			senderNameResource,
			customerExperiencesNavigationResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
